import {
  Phone,
  MessageSquare,
  Network,
  Shield,
  Building2,
  Cloud,
  BarChart3,
  Bot,
  Headphones,
  type LucideIcon,
} from 'lucide-react'

export interface NavItem {
  title: string
  href: string
  description?: string
  icon?: LucideIcon
}

export interface NavGroup {
  title: string
  items: NavItem[]
}

export const solutionsNav: NavItem[] = [
  {
    title: 'UCaaS',
    href: '/solutions/ucaas',
    description: 'Unified Communications as a Service - Voice, video, messaging in one platform',
    icon: Phone,
  },
  {
    title: 'CCaaS',
    href: '/solutions/ccaas',
    description: 'Contact Center as a Service - Omnichannel customer engagement',
    icon: MessageSquare,
  },
  {
    title: 'Network Solutions',
    href: '/solutions/network',
    description: 'Enterprise networking infrastructure and connectivity',
    icon: Network,
  },
  {
    title: 'SD-WAN',
    href: '/solutions/sd-wan',
    description: 'Software-defined wide area network for distributed enterprises',
    icon: Network,
  },
  {
    title: 'Cybersecurity',
    href: '/solutions/cybersecurity',
    description: 'Comprehensive security solutions to protect your business',
    icon: Shield,
  },
]

export const industriesNav: NavItem[] = [
  {
    title: 'Credit Unions',
    href: '/industries/credit-unions',
    description: 'Technology solutions designed for credit union operations',
    icon: Building2,
  },
  {
    title: 'Banks & Financial Services',
    href: '/industries/banking',
    description: 'Enterprise solutions for banking and financial institutions',
    icon: Building2,
  },
]

export const assessmentsNav: NavItem[] = [
  {
    title: 'Cyber Security',
    href: '/assessments/cybersecurity',
    description: 'Comprehensive security evaluation using the Cyber Pyramid framework',
    icon: Shield,
  },
  {
    title: 'Cloud',
    href: '/assessments/cloud',
    description: 'Strategic cloud readiness and migration assessment',
    icon: Cloud,
  },
  {
    title: 'Network',
    href: '/assessments/network',
    description: 'Internet, SD-WAN, and network infrastructure optimization',
    icon: Network,
  },
  {
    title: 'Data Analytics',
    href: '/assessments/data-analytics',
    description: 'Data strategy and analytics maturity assessment',
    icon: BarChart3,
  },
  {
    title: 'AI',
    href: '/assessments/ai',
    description: 'AI readiness and use case identification',
    icon: Bot,
  },
  {
    title: 'UCaaS',
    href: '/assessments/ucaas',
    description: 'Unified communications modernization assessment',
    icon: Phone,
  },
  {
    title: 'Contact Center',
    href: '/assessments/contact-center',
    description: 'Contact center optimization and CCaaS evaluation',
    icon: Headphones,
  },
]

export const mainNav: Array<{ title: string; href: string; children?: NavItem[] }> = [
  { title: 'Home', href: '/' },
  {
    title: 'Solutions',
    href: '/solutions',
    children: solutionsNav,
  },
  {
    title: 'Assessments',
    href: '/assessments',
    children: assessmentsNav,
  },
  {
    title: 'Industries',
    href: '/industries',
    children: industriesNav,
  },
  { title: 'About', href: '/about' },
  { title: 'Contact', href: '/contact' },
]

export const footerNav = {
  solutions: [
    { title: 'UCaaS', href: '/solutions/ucaas' },
    { title: 'CCaaS', href: '/solutions/ccaas' },
    { title: 'Network', href: '/solutions/network' },
    { title: 'SD-WAN', href: '/solutions/sd-wan' },
    { title: 'Cybersecurity', href: '/solutions/cybersecurity' },
  ],
  assessments: [
    { title: 'Cyber Security', href: '/assessments/cybersecurity' },
    { title: 'Cloud', href: '/assessments/cloud' },
    { title: 'Network', href: '/assessments/network' },
    { title: 'Data Analytics', href: '/assessments/data-analytics' },
    { title: 'AI', href: '/assessments/ai' },
    { title: 'UCaaS', href: '/assessments/ucaas' },
    { title: 'Contact Center', href: '/assessments/contact-center' },
  ],
  industries: [
    { title: 'Credit Unions', href: '/industries/credit-unions' },
    { title: 'Banks & Financial Services', href: '/industries/banking' },
  ],
  company: [
    { title: 'About Us', href: '/about' },
    { title: 'Contact', href: '/contact' },
    { title: 'Privacy Policy', href: '/privacy' },
    { title: 'Terms & Conditions', href: '/terms' },
  ],
}


